module.exports = __webpack_public_path__ + "static/media/pastelcamarao.9feb32c0.webp";